import type { AllRouteEndpoints } from "../routeTypes";

export const campaignQaRun = "/:app_group_id/campaign_qa_runs/:campaign_id";

export const campaignQaRunCacheKeys: AllRouteEndpoints[] = ["/:app_group_id/campaign_qa_runs/:campaign_id"];

/**
 * The react-query key `useDashboardApiQuery` builds for the QA run GET
 * (`[{ cacheKey, appGroupId }, ...params]`). Writers use it with
 * `queryClient.setQueryData` to publish what they stored into the cache
 * synchronously, so readers see it without waiting on the refetch that the
 * mutation adapter's invalidation kicks off in the background.
 */
export const getCampaignQaRunQueryKey = (appGroupId: string, campaignId: string) => [
  { cacheKey: campaignQaRun, appGroupId },
  { appGroupId, campaignId },
];
